import moment from "moment";

export const PENDING_STATUS = {
  SET_DATE: "set_date",
  DUE_TODAY: "due_today",
  DUE_TOMORROW: "due_tomorrow",
  PENDING: "pending",
  NONE: "none",
};

export const getPendingCollectionStatus = (collectAt, I18n) => {
  if (!collectAt) {
    return {
      type: PENDING_STATUS.SET_DATE,
      label: I18n.set_collection_date || "Set collection date",
    };
  }

  const today = moment().startOf("day");
  const tomorrow = moment().add(1, "day").startOf("day");
  const collectDate = moment(collectAt).startOf("day");

  if (collectDate.isSame(today)) {
    return {
      type: PENDING_STATUS.DUE_TODAY,
      label: I18n.due_today || "Due today",
    };
  }

  if (collectDate.isSame(tomorrow)) {
    return {
      type: PENDING_STATUS.DUE_TOMORROW,
      label: I18n.due_tomorrow || "Due tomorrow",
    };
  }

  if (collectDate.isBefore(today)) {
    return {
      type: PENDING_STATUS.PENDING,
      label: I18n.pending || "Pending",
    };
  }

  return {
    type: PENDING_STATUS.NONE,
    label: moment(collectAt).format("DD-MM-YYYY"),
  };
};
